import ReactQuill from 'react-quill-new';

export const reactQuillDefaultModules: ReactQuill.ReactQuillProps['modules'] = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ align: [] }],
    [{ size: ['small', false, 'large', 'huge'] }],
    [{ font: [], fontSize: [10, 12, 14, 16] }],
    [{ color: [] }, { background: [] }],
    ['link'],
  ],
  clipboard: {
    allowed: {
      tags: [],
      attributes: ['href', 'rel', 'target', 'class'],
    },
    keepSelection: true,
    substituteBlockElements: true,
    magicPasteLinks: true,
  },
};
